(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[215],{

/***/ 5215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@1.7.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(9034);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(9496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.3.1_react@17.0.2/node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(4583);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@4.3.1_react@17.0.2/node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(999);
// EXTERNAL MODULE: ./src/layout/index.ts + 16 modules
var layout = __webpack_require__(7818);
// EXTERNAL MODULE: ./src/layouts/index.ts + 2 modules
var layouts = __webpack_require__(2039);
// EXTERNAL MODULE: ./src/utils/index.ts + 10 modules
var utils = __webpack_require__(7925);
// EXTERNAL MODULE: ./src/views/common/sections/index.ts + 1 modules
var sections = __webpack_require__(3916);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+color-mode@1.4.6_react@17.0.2/node_modules/@chakra-ui/color-mode/dist/chakra-ui-color-mode.esm.js
var chakra_ui_color_mode_esm = __webpack_require__(9262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+system@1.11.2_@emotion+react@11.8.1_@emotion+styled@11.8.1_react@17.0.2/node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 3 modules
var chakra_ui_system_esm = __webpack_require__(3879);
// EXTERNAL MODULE: ./src/components/index.ts + 4 modules
var components = __webpack_require__(3890);
// EXTERNAL MODULE: ./src/utils/i18n.ts + 1 modules
var i18n = __webpack_require__(6569);
;// CONCATENATED MODULE: ./src/views/home/sections/main-banner.tsx






var defLocal = {
    bgAlpha: "0.2",
    textShadow: "3px 3px 10px rgb(64 64 64 / 5%)",
    message: {
        maxW: "560px",
        mx: "auto",
        fontSize: {
            base: "lg",
            lg: "xl"
        }
    }
};
var MainBannerSection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        as: "section",
        h: "100vh",
        display: "flex",
        alignItems: "center",
        bg: "linear-gradient(0deg, rgba(0, 0, 0, ".concat(defLocal.bgAlpha, "), rgba(0, 0, 0, ").concat(defLocal.bgAlpha, ")), url('/pages/home/banner.jpg')"),
        bgPos: "center",
        bgSize: "cover",
        bgAttachment: "fixed",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Container */.W2, {
            pos: "relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                textAlign: "center",
                color: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("whiteAlpha.900", "whiteAlpha.900"),
                pos: "relative",
                right: {
                    base: "2vw",
                    md: "3vw"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_system_esm/* chakra.h1 */.m$.h1, {
                        textStyle: "main-banner.heading",
                        maxW: {
                            base: "8.3ch",
                            lg: "9ch"
                        },
                        mb: "16px",
                        mx: "auto",
                        textAlign: "right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                as: "div",
                                color: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("whiteAlpha.900", "whiteAlpha.900"),
                                textShadow: defLocal.textShadow,
                                children: (0,i18n.t)("pages.home.sections.main-banner.title.main1")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                                as: "div",
                                color: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("whiteAlpha.900", "whiteAlpha.900"),
                                textShadow: defLocal.textShadow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        as: "span",
                                        fontWeight: "semibold",
                                        mr: "0.9rem",
                                        children: "+"
                                    }),
                                    (0,i18n.t)("pages.home.sections.main-banner.title.main2")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                                as: "div",
                                color: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("whiteAlpha.900", "whiteAlpha.900"),
                                textShadow: defLocal.textShadow,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                        as: "span",
                                        fontWeight: "semibold",
                                        mr: {
                                            base: "2.2rem",
                                            md: "3.55rem"
                                        },
                                        children: "="
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* TextUnderline */.nC, {
                                        colorLight: "whiteAlpha.900",
                                        children: (0,i18n.t)("pages.home.sections.main-banner.title.brand")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        as: "span",
                        textStyle: "main-banner.description",
                        color: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("whiteAlpha.900", "whiteAlpha.900"),
                        mt: 6,
                        pos: "relative",
                        left: {
                            base: "2vw",
                            md: "3vw"
                        },
                        fontSize: {
                            md: "2xl"
                        },
                        children: (0,i18n.t)("pages.home.sections.main-banner.message1")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* ResponsiveBr */.e5, {
                        breakpoint: "md"
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.8.1_@babel+core@7.17.5_@types+react@17.0.39_react@17.0.2/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(8647);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+image@1.1.8_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/image/dist/chakra-ui-image.esm.js
var chakra_ui_image_esm = __webpack_require__(7080);
;// CONCATENATED MODULE: ./src/views/home/sections/partners.tsx




var moveSlideshow = (0,emotion_react_browser_esm/* keyframes */.F4)({
    '0%': {
        transform: "translateX(0%)"
    },
    '100%': {
        transform: "translateX(-50%)"
    }
});
var PartnersSection = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "partners",
        // OPTIONAL
        sectionSize: layout/* SectionSize.LG */.f3.LG,
        title: (0,utils.t)("pages.home.sections.partners.title"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
            boxSizing: "border-box",
            m: "0 auto",
            maxW: "1200px",
            p: "0 10px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                className: "slideshow",
                h: "380px",
                m: "0 auto",
                maxW: "1180px",
                overflow: "hidden",
                pos: "relative",
                w: {
                    base: "100%",
                    md: "80vw"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Img */.Ei, {
                        className: "shadow left",
                        src: "/logos/slideshow_shadow.png",
                        alt: "Left Shadow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Img */.Ei, {
                        className: "shadow right",
                        src: "/logos/slideshow_shadow.png",
                        alt: "Right Shadow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Img */.Ei, {
                        className: "logo",
                        animation: "".concat(moveSlideshow, " 40s linear infinite"),
                        maxW: "none",
                        src: "/logos/slideshow_partners.jpg",
                        alt: "Partner Logo Slideshow"
                    })
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./configs/motion-presets.ts + 1 modules
var motion_presets = __webpack_require__(4324);
// EXTERNAL MODULE: ./src/components/chakra-ui/framer-motion/index.ts + 2 modules
var framer_motion = __webpack_require__(7994);
;// CONCATENATED MODULE: ./src/views/home/sections/steps.tsx






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FloatingBox = function(param) {
    var iconPath = param.iconPath, title = param.title, text = param.text;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(framer_motion/* MotionBox */.uH, _objectSpread({
        bg: (0,chakra_ui_color_mode_esm/* useColorModeValue */.ff)("white", "gray.700"),
        fontSize: "2rem",
        p: {
            base: "1.2rem",
            md: "1.8rem 4.4rem"
        },
        rounded: "xl",
        shadow: "md",
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        transitionTimingFunction: "ease-in-out",
        _hover: {
            shadow: "xl"
        }
    }, motion_presets/* motionFadeUpSlowProps */.l, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            align: "center",
            minH: "5.75rem",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Image */.Ee, {
                    src: iconPath,
                    alt: "icon_".concat(title),
                    w: {
                        base: "52px",
                        md: "80px"
                    },
                    mr: {
                        base: "0.95rem",
                        md: "3rem"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    align: "flex-start",
                    flexDir: "column",
                    w: "74%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                            as: "h3",
                            flex: "1 1",
                            textAlign: "left",
                            textStyle: "content.title-sm",
                            fontSize: {
                                base: "0.9rem",
                                md: "1.4rem"
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Divider */.iz, {
                            color: "gray.700",
                            height: "2px !important",
                            mt: "0.2rem",
                            mb: "0.4rem",
                            opacity: "0.2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            as: "span",
                            flex: "1 1",
                            textStyle: "content.body-md",
                            fontSize: {
                                base: "0.85rem",
                                md: "1.1rem"
                            },
                            children: text
                        })
                    ]
                })
            ]
        })
    }), "stepsSectionBox".concat(title));
};
var StepsSection = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "steps",
        // OPTIONAL
        title: "Core Value",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "이노앤엠만의 체계화된 마케팅 계획으로 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* ResponsiveBr */.e5, {
                    breakpoint: "md"
                }),
                "확실한 결과를 보장해드립니다."
            ]
        }),
        sectionSize: layout/* SectionSize.MD */.f3.MD,
        sectionType: layout/* SectionType.LIGHT */.bA.LIGHT,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            flexDir: "column",
            gap: {
                base: "2.5rem",
                md: "3rem"
            },
            maxW: "768px",
            mx: "auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingBox, {
                    iconPath: "/pages/home/sections/steps/icon_1.png",
                    title: "CUSTOMER WITH",
                    text: "클라이언트의 성공은 곧 이노앤엠의 성장을 위한 자양분입니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingBox, {
                    iconPath: "/pages/home/sections/steps/icon_2.png",
                    title: "PROGRESSIVELY RESEARCH",
                    text: "보다 효과적인 솔루션을 이끌어내기 위하여 끊임없이 연구합니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingBox, {
                    iconPath: "/pages/home/sections/steps/icon_3.png",
                    title: "TRENDY MARKETING",
                    text: "변화무쌍한 시대에 맞춰 트렌드를 주도하는 마케팅을 실현합니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingBox, {
                    iconPath: "/pages/home/sections/steps/icon_4.png",
                    title: "HIGH-QUALITY SERVICE",
                    text: "클라이언트와 소비자 모두가 만족하는 HIGH-QUALITY의 마케팅 서비스를 제공합니다."
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/views/home/sections/works.tsx








function works_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function works_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            works_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var log = (0,utils/* createLog */.xN)("WorksSection");
var Feature = function(param) {
    var idx = param.idx, iconPath = param.iconPath, title = param.title, // OPTIONAL
    descriptions = param.descriptions, boxProps = param.boxProps, _floatingDelayBase = param.floatingDelayBase, floatingDelayBase = _floatingDelayBase === void 0 ? 0.2 : _floatingDelayBase, _floatingDelayMobile = param.floatingDelayMobile, floatingDelayMobile = _floatingDelayMobile === void 0 ? 0.5 : _floatingDelayMobile, _floatingDelayMult = param.floatingDelayMult, floatingDelayMult = _floatingDelayMult === void 0 ? 0.3 : _floatingDelayMult, _floatingDuration = param.floatingDuration, floatingDuration = _floatingDuration === void 0 ? 0.6 : _floatingDuration, FeatureIcon = param.icon;
    var isMobile = (0,utils/* useGridProps */.by)().isMobile;
    (0,react.useEffect)(function() {
        log.debug("FeatureIcon '".concat(FeatureIcon === null || FeatureIcon === void 0 ? void 0 : FeatureIcon.name, "' is loaded but ignored"));
    }, [
        FeatureIcon === null || FeatureIcon === void 0 ? void 0 : FeatureIcon.name
    ]);
    var floatingDelay = (0,react.useMemo)(function() {
        return isMobile ? floatingDelayMobile : floatingDelayBase + floatingDelayMult * (idx + 1);
    }, [
        floatingDelayBase,
        floatingDelayMobile,
        floatingDelayMult,
        idx,
        isMobile
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion/* MotionBox */.uH, works_objectSpread({
        p: "0"
    }, motion_presets/* motionFadeUpSlowProps */.l, boxProps, {
        transition: {
            delay: floatingDelay,
            duration: floatingDuration
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            align: "center",
            flexDir: "column",
            justify: "center",
            textAlign: "left",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_image_esm/* Image */.Ee, {
                    src: iconPath,
                    alt: "icon_".concat(title),
                    maxH: "80px",
                    mb: "0.75rem"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    as: "h3",
                    textStyle: "content.title-sm",
                    my: "0.5rem",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    textStyle: "content.body-md",
                    fontSize: {
                        base: "1rem",
                        md: "1.05rem"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* UnorderedList */.QI, {
                        ml: {
                            base: "16px",
                            md: "4px"
                        },
                        children: descriptions === null || descriptions === void 0 ? void 0 : descriptions.map(function(desc, descIdx) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                                children: desc
                            }, "worksSectionDesc".concat(desc, "Idx").concat(descIdx));
                        })
                    })
                })
            ]
        })
    }), "works-section-feature-".concat(title)));
};
var WorksSection = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "works",
        // OPTIONAL
        px: {
            base: "0.75rem",
            md: "0"
        },
        containerProps: {
            maxW: "90rem"
        },
        sectionSize: layout/* SectionSize.LG */.f3.LG,
        sectionType: layout/* SectionType.LIGHT */.bA.LIGHT,
        title: (0,i18n.t)("pages.home.sections.works.title"),
        titleTextUnderlineDividerProps: {
            underlineMarginBottom: "1rem"
        },
        description: (0,i18n.tl)("pages.home.sections.works.descriptions"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            flexDir: {
                base: "column",
                md: "row"
            },
            gap: {
                base: "4.5rem",
                md: "3rem"
            },
            pt: {
                base: "2rem",
                md: "0.75rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                    idx: 0,
                    iconPath: "/pages/home/sections/works/icon_1.png",
                    title: (0,i18n.t)("pages.home.sections.works.item1.title"),
                    descriptions: (0,i18n.tl)("pages.home.sections.works.item1.descriptions")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                    idx: 1,
                    iconPath: "/pages/home/sections/works/icon_2.png",
                    title: (0,i18n.t)("pages.home.sections.works.item2.title"),
                    descriptions: (0,i18n.tl)("pages.home.sections.works.item2.descriptions")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                    idx: 2,
                    iconPath: "/pages/home/sections/works/icon_3.png",
                    title: (0,i18n.t)("pages.home.sections.works.item3.title"),
                    descriptions: (0,i18n.tl)("pages.home.sections.works.item3.descriptions")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                    idx: 3,
                    iconPath: "/pages/home/sections/works/icon_4.png",
                    title: (0,i18n.t)("pages.home.sections.works.item4.title"),
                    descriptions: (0,i18n.tl)("pages.home.sections.works.item4.descriptions")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                    idx: 4,
                    iconPath: "/pages/home/sections/works/icon_5.png",
                    title: (0,i18n.t)("pages.home.sections.works.item5.title"),
                    descriptions: (0,i18n.tl)("pages.home.sections.works.item5.descriptions")
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+icons@1.1.7_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(2303);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+accordion@1.4.9_@chakra-ui+system@1.11.2_framer-motion@6.2.8_react@17.0.2/node_modules/@chakra-ui/accordion/dist/chakra-ui-accordion.esm.js + 1 modules
var chakra_ui_accordion_esm = __webpack_require__(1331);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+icon@2.0.5_@chakra-ui+system@1.11.2_react@17.0.2/node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(7418);
;// CONCATENATED MODULE: ./src/views/home/sections/specialty/specialty-mobile.tsx





function specialty_mobile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function specialty_mobile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            specialty_mobile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SpecialtyAccordionItem = function(param1) {
    var idx = param1.idx, slideItem = param1.slideItem, _color = param1.// OPTIONAL
    color, color = _color === void 0 ? "white" : _color, _rounded = param1.rounded, rounded = _rounded === void 0 ? "md" : _rounded;
    var titleIcon = slideItem.titleIcon, _titles = slideItem.titles, titles = _titles === void 0 ? "<TITLE>" : _titles, _body = slideItem.body, body = _body === void 0 ? "Lorem Ipsum is simply dummy text of the printing and typesetting industry.  Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book." : _body, _url = slideItem.url, url = _url === void 0 ? "/" : _url;
    var _bgAlpha;
    var bgAlpha = (0,react.useMemo)(function() {
        return (_bgAlpha = slideItem.bgAlpha) !== null && _bgAlpha !== void 0 ? _bgAlpha : 0.45;
    }, [
        slideItem
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_accordion_esm/* AccordionItem */.Qd, {
        children: function(param) {
            var isExpanded = param.isExpanded;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                bg: "linear-gradient(\n          to bottom,\n          rgba(23, 24, 32, ".concat(bgAlpha, "),\n          rgba(23, 24, 32, ").concat(bgAlpha, ")\n        ), url('").concat(slideItem.bgPath, "')"),
                bgPos: "70% center",
                bgSize: "cover",
                color: color,
                filter: isExpanded ? "grayscale(0.2)" : "grayscale(0.9)",
                py: "0.75rem",
                px: "1rem",
                roundedBottom: idx === 3 && rounded,
                roundedTop: idx === 0 && rounded,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_accordion_esm/* AccordionButton */.KF, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                align: "center",
                                flex: "1",
                                fontSize: "1rem",
                                gap: "0.4rem",
                                textAlign: "left",
                                textShadow: "0 0 1px rgba(255, 255, 255, 0.4)",
                                transform: isExpanded ? "translateY(1.5rem)" : "",
                                transitionDuration: "normal",
                                transitionProperty: "all",
                                transitionTimingFunction: "ease-in-out",
                                children: [
                                    titleIcon,
                                    titles[0]
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                as: chakra_ui_icons_esm/* ChevronLeftIcon */.wy,
                                transitionDuration: "normal",
                                transitionProperty: "all",
                                transitionTimingFunction: "ease-in-out",
                                transform: isExpanded ? "translateY(1.5rem) rotate(-90deg)" : "",
                                w: 6,
                                h: 6
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_accordion_esm/* AccordionPanel */.Hk, {
                        fontSize: "0.9rem",
                        fontWeight: "700",
                        p: "1.5rem 0rem",
                        textShadow: "0 0 1px rgba(255, 255, 255, 0.4)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Divider */.iz, {
                                my: "1.25rem",
                                color: "#eee",
                                opacity: 0.6
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                                href: url,
                                children: body
                            })
                        ]
                    })
                ]
            });
        }
    }));
};
var SpecialtyMobileSection = function(param) {
    var slideItems = param.slideItems, // OPTIONAL
    sectionProps = param.sectionProps;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, specialty_mobile_objectSpread({
        title: "Service Scope"
    }, sectionProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_accordion_esm/* Accordion */.UQ, {
            defaultIndex: [
                0
            ],
            transitionProperty: "all",
            transitionDuration: "ultra-fast",
            transitionTimingFunction: "cubic-bezier(0.19, 0.72, 0.39, 0.78)",
            children: slideItems.map(function(item, i) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(SpecialtyAccordionItem, {
                    idx: i,
                    slideItem: item
                }, i);
            })
        })
    })));
};
/* harmony default export */ var specialty_mobile = (SpecialtyMobileSection);

// EXTERNAL MODULE: ./node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(9803);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.0_@babel+core@7.17.5_react-dom@17.0.2_react@17.0.2_sass@1.49.9/node_modules/next/dist/client/router.js
var client_router = __webpack_require__(9048);
// EXTERNAL MODULE: ./configs/index.ts + 5 modules
var configs = __webpack_require__(9457);
// EXTERNAL MODULE: ./src/views/home/sections/specialty/specialty.module.scss
var specialty_module = __webpack_require__(524);
var specialty_module_default = /*#__PURE__*/__webpack_require__.n(specialty_module);
;// CONCATENATED MODULE: ./src/views/home/sections/specialty/slide.tsx




function slide_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Slide = function(param) {
    var active = param.active, handleClick = param.handleClick, handleFocus = param.handleFocus, handleHover = param.handleHover, idx = param.idx, item = param.item;
    var _titles = item.titles, titles = _titles === void 0 ? "<TITLE>" : _titles, _body = item.body, body = _body === void 0 ? "Lorem Ipsum is simply dummy text of the printing and typesetting industry.  Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book." : _body, _url = item.url, url = _url === void 0 ? "/" : _url;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((specialty_module_default()).slide, slide_defineProperty({}, (specialty_module_default()).active, active)),
        role: "button",
        tabIndex: idx,
        onClick: handleClick(titles[0], idx, url),
        onMouseOver: handleHover(titles[0], idx),
        onFocus: handleFocus(titles[0], idx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (specialty_module_default()).titleWrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (specialty_module_default()).titleWrap1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (specialty_module_default()).titleIcon,
                                children: item.titleIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (specialty_module_default()).text,
                                children: titles[0]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (specialty_module_default()).titleWrap2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (specialty_module_default()).titleIcon,
                            children: item.titleIcon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (specialty_module_default()).contentWrap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (specialty_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (specialty_module_default()).contentInner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: (specialty_module_default()).title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (specialty_module_default()).titleIcon,
                                        children: item.titleIcon
                                    }),
                                    titles[1]
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (specialty_module_default()).body,
                                children: body
                            })
                        ]
                    })
                })
            })
        ]
    }, titles[0]));
};
/* harmony default export */ var slide = (Slide);

;// CONCATENATED MODULE: ./src/views/home/sections/specialty/specialty.tsx










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function specialty_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var specialty_log = (0,utils/* createLog */.xN)("SpecialtySection");
var SpecialtySection = function(param) {
    var slideItems = param.slideItems;
    var router = (0,client_router.useRouter)();
    var ref = _slicedToArray((0,utils/* useStateL */.Fs)(undefined, "activeSlideIdx"), 2), activeSlideIdx = ref[0], setActiveSlideIdx = ref[1];
    var handleMouseEnterSlide = function() {
        if (configs/* NODE_ENV */.lC !== configs/* NodeEnv.PROD */.$X.PROD) specialty_log.debug("onMouseEnter slides");
    };
    var handleMouseLeaveSlide = function() {
        if (configs/* NODE_ENV */.lC !== configs/* NodeEnv.PROD */.$X.PROD) specialty_log.debug("onMouseLeave slides");
        setActiveSlideIdx(undefined);
    };
    var content = (0,react.useMemo)(function() {
        var result = [];
        var handleClickSlide = function(title, i, url) {
            return function(e) {
                e === null || e === void 0 ? void 0 : e.preventDefault();
                specialty_log.debug("handleClickSlide(".concat(title, ", ").concat(i, ", ").concat(url, ")"));
                router.push(url);
            };
        };
        var handleFocusSlide = function(title, i) {
            return function(e) {
                e === null || e === void 0 ? void 0 : e.preventDefault();
                specialty_log.debug("handleFocusSlide(".concat(title, ", ").concat(i, ")"));
            };
        };
        var handleHoverSlide = function(title, i) {
            return function(e) {
                e === null || e === void 0 ? void 0 : e.preventDefault();
                specialty_log.debug("handleHoverSlide(".concat(title, ", ").concat(i, ")"));
                setActiveSlideIdx(i);
            };
        };
        slideItems === null || slideItems === void 0 ? void 0 : slideItems.forEach(function(item, i) {
            return result.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(slide, {
                idx: i,
                item: slideItems[i],
                active: activeSlideIdx === i,
                handleClick: handleClickSlide,
                handleFocus: handleFocusSlide,
                handleHover: handleHoverSlide
            }, item.titles[0]));
        });
        return result;
    }, [
        activeSlideIdx,
        router,
        setActiveSlideIdx,
        slideItems
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* GeneralSection */.d, {
        name: "specialty",
        // OPTIONAL
        title: "Service Scope",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "디지털 마케팅에 가장 최적화된",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* ResponsiveBr */.e5, {
                    breakpoint: "md"
                }),
                "서비스를 제공합니다."
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
            px: "3rem",
            pt: {
                '3xl': "0.5rem"
            },
            pb: {
                '3xl': "0.5rem"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                className: classnames_default()((specialty_module_default()).slides, specialty_defineProperty({}, (specialty_module_default()).active, activeSlideIdx !== undefined)),
                onMouseEnter: handleMouseEnterSlide,
                onMouseLeave: handleMouseLeaveSlide,
                h: {
                    'base': "55vh",
                    '3xl': "50vh"
                },
                children: content
            })
        })
    }));
};
/* harmony default export */ var specialty = (SpecialtySection);

;// CONCATENATED MODULE: ./src/views/home/sections/index.ts







;// CONCATENATED MODULE: ./src/pages/home.tsx










function home_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function home_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function home_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function home_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function home_slicedToArray(arr, i) {
    return home_arrayWithHoles(arr) || home_iterableToArrayLimit(arr, i) || home_unsupportedIterableToArray(arr, i) || home_nonIterableRest();
}
function home_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return home_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return home_arrayLikeToArray(o, minLen);
}
var UNIT_NAME = "HomePage";
var slideItems = [
    {
        titleIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsChatSquareDots */.g8F, {}),
        titles: [
            "바이럴 마케팅",
            "바이럴 마케팅 | Viral Marketing"
        ],
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    mb: "0.75rem",
                    children: "온라인 상의 커뮤니티 공간을 통해 자사 브랜드의 가치를 높일 수 있는 마케팅 방법이며, 광고주와 소비자 간의 양방향 소통으로 신뢰를 쌓을 수 있다는 장점이 있습니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* UnorderedList */.QI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: "블로그 체험단"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: "인스타그램 체험단"
                        })
                    ]
                })
            ]
        }),
        bgPath: "/pages/business/viral/sections/about/bg_1.webp",
        url: "/business/viral"
    },
    {
        titleIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsInstagram */.Vs6, {}),
        titles: [
            "SNS 운영대행",
            "SNS 운영대행 | SNS Marketing"
        ],
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    mb: "0.75rem",
                    children: "브랜드 아이덴티티를 반영한 컨셉 및 운영 전략을 수립하고 소비자와의 양방향 커뮤니케이션으로 브랜드 채널을 운영해 드립니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* UnorderedList */.QI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: "페이스북 브랜드 채널 운영대행"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: "인스타그램 브랜드 채널 운영대행"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: "블로그 브랜드 채널 운영대행"
                        })
                    ]
                })
            ]
        }),
        bgPath: "/pages/business/sns/sections/about/bg_1.png",
        url: "/business/sns"
    },
    {
        titleIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaTv */.RsC, {}),
        titles: [
            "언론 송출",
            "언론 송출 | Media Transmission"
        ],
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    mb: "0.75rem",
                    children: "기업 및 브랜드에 있어서 가장 직접적인 PR방법으로 기업의 이슈를 보도매체 통하여 뉴스기사 송부하여 주요 포털 사이트인 네이버, 다음, 네이트에 클라이언트 기업의 브랜드 및 상품을 노출시킵니다."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* UnorderedList */.QI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: "포털 사이트 뉴스 섹션에 노출되는 국내 주요 150여개 언론사와 제휴"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                            children: "전문성으로 무장한 업종별 맞춤 고품질 원고자의 콘텐츠 생성"
                        })
                    ]
                })
            ]
        }),
        bgPath: "/pages/business/media/sections/about/bg_1.png",
        url: "/business/media",
        // OPTIONAL
        bgAlpha: 0.6
    },
    {
        titleIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsFillBarChartLineFill */.UXB, {}),
        titles: [
            "종합 마케팅",
            "종합 마케팅 | Comprehensive Marketing"
        ],
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* UnorderedList */.QI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                        children: "모니터링 및 리서치"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                        children: "유튜브 체험단"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                        children: "미스터리 쇼퍼"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                        children: "영상 촬영"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                        children: "연예인 & 셀럽 PPL"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* ListItem */.HC, {
                        children: "옥외광고"
                    })
                ]
            })
        }),
        bgPath: "/pages/business/marketing/sections/about/heading_5.png",
        url: "/business/marketing"
    }, 
];
var HomePage = function() {
    var log = (0,utils/* useLog */.Tx)(UNIT_NAME);
    var isMobile = (0,utils/* useGridProps */.by)().isMobile;
    var ref = home_slicedToArray((0,utils/* useStateL */.Fs)(false, "showNextPageButton"), 2), showNextPageButton = ref[0], setShowNextPageButton = ref[1];
    var handleContactSectionInView = (0,react.useCallback)(function(inView, entry) {
        log.debug("inView: ".concat(inView, ", inViewEntry: ").concat(JSON.stringify(entry)));
        setShowNextPageButton(inView);
    }, [
        log,
        setShowNextPageButton
    ]);
    var ref1 = (0,react.useState)(null), specialtySection = ref1[0], setSpecialtySection = ref1[1];
    (0,react.useEffect)(function() {
        // prettier-ignore
        switch(isMobile){
            case true:
                setSpecialtySection(/*#__PURE__*/ (0,jsx_runtime.jsx)(specialty_mobile, {
                    slideItems: slideItems
                }));
                break;
            case false:
                setSpecialtySection(/*#__PURE__*/ (0,jsx_runtime.jsx)(specialty, {
                    slideItems: slideItems
                }));
                break;
            default:
                break;
        }
    }, [
        isMobile
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* PageLayout */.Xg, {
        nextPageHref: "/about",
        seoProps: {
            title: (0,utils.t)("pages.home.seo.title"),
            description: (0,utils.t)("pages.home.seo.description")
        },
        // showFloatingButtons
        showNextPageButton: showNextPageButton,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBannerSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsSection, {}),
            specialtySection,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WorksSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sections/* ContactSection */.U, {
                handleInView: handleContactSectionInView
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Footer */.$_, {})
        ]
    }));
};
/* harmony default export */ var home = (HomePage);


/***/ }),

/***/ 524:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slides":"specialty_slides___ive8","slide":"specialty_slide__dG113","titleWrap":"specialty_titleWrap__fUPr7","titleIcon":"specialty_titleIcon__G7IjB","titleWrap1":"specialty_titleWrap1__etZUD","text":"specialty_text__9FccF","titleWrap2":"specialty_titleWrap2__WGqSE","contentWrap":"specialty_contentWrap__g_gY7","content":"specialty_content__Q34rW","contentInner":"specialty_contentInner__3kAkZ","title":"specialty_title__rNZ3C","body":"specialty_body__rjSa4","active":"specialty_active__PjIWk"};

/***/ })

}]);